import 'lazysizes'
import 'babel-polyfill'
import 'js/polyfills/customEvent'
import 'js/polyfills/closest'

// =utils
import 'js/utils/breakpoints'
import 'js/utils/detectTouch'
import 'js/utils/doc-height'

import 'js/animations/lazyload-refresh'

if (document.querySelector('[data-height="equal"]')) {
  import(/* webpackPrefetch: true, webpackChunkName: "utilEqualHeight" */ 'js/utils/equalHeight')
}

if (document.querySelector('.js-button')) {
  import(/* webpackPrefetch: true, webpackChunkName: "utilButtonDecoration" */ 'js/utils/buttonDecoration')
}

// debug mode
if (document.querySelector('body').classList.contains('-debug')) {
  import(/* webpackPrefetch: true, webpackChunkName: "debugger" */ 'js/utils/debugger')
}

//===============================================================/
//  =components
//===============================================================/

if (document.querySelector('.cookie-consent')) {
  import(/* webpackPrefetch: true, webpackChunkName: "compCookieConsent" */ 'js/components/cookieConsent')
}

if (document.querySelector('.js-login')) {
  import(/* webpackPrefetch: true, webpackChunkName: "componentLogin" */ 'js/components/login')
}

if (document.querySelector('.js-form')) {
  import(/* webpackPrefetch: true, webpackChunkName: "componentFormShortcode" */ 'js/components/form-shortcode')
}

if (document.querySelector('.js-filter-form')) {
  import(/* webpackPrefetch: true, webpackChunkName: "filtering" */ 'js/components/filtering')
  import(/* webpackPrefetch: true, webpackChunkName: "filterAnimation" */ 'js/animations/components/filters')
}

//===============================================================/
//  =blocks
//===============================================================/

if (document.querySelector('.js-image-carousel')) {
  import(/* webpackPrefetch: true, webpackChunkName: "imageGallery" */ 'js/blocks/image-gallery')
}

if (document.querySelector('.js-testimonials')) {
  import(/* webpackPrefetch: true, webpackChunkName: "testimonial" */ 'js/blocks/testimonial')
}

if (document.querySelector('.js-accordion')) {
  import(/* webpackPrefetch: true, webpackChunkName: "accordion" */ 'js/blocks/accordion')
}

if (document.querySelector('.js-tag-carousel')) {
  import(/* webpackPrefetch: true, webpackChunkName: "tagCarousel" */ 'js/blocks/tag-carousel')
}

if (document.querySelector('.js-prequalifying-calculator')) {
  import(/* webpackPrefetch: true, webpackChunkName: "prequalifyingCalculator" */ 'js/blocks/prequalifying-calculator')
}

if (document.querySelector('.js-video')) {
  import(/* webpackPrefetch: true, webpackChunkName: "video" */ 'js/blocks/video')
}

//===============================================================/
//  =layout
//===============================================================/

if (document.querySelector('.nav-mains')) {
  import(/* webpackPrefetch: true, webpackChunkName: "layoutNav" */ 'js/layouts/nav')
}

//===============================================================/
//  =pages
//===============================================================/

if (document.querySelector('.js-case-study')) {
  import(/* webpackPrefetch: true, webpackChunkName: "caseStudyAnimation" */ 'js/animations/pages/case-study')
}

if (document.querySelector('.js-video-item')) {
  import(/* webpackPrefetch: true, webpackChunkName: "videoListAnimation" */ 'js/animations/pages/video-list')
  import(/* webpackPrefetch: true, webpackChunkName: "videoList" */ 'js/pages/video-list')
}

//===============================================================/
//  =animations
//===============================================================/

if (document.querySelector('.js-nav-main-toggler')) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationNavigation" */ 'js/animations/navigation')
}

if (document.querySelector('.js-hero')) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationHero" */ 'js/animations/blocks/hero')
}

if (
  document.querySelector('.js-two-column-image') ||
  document.querySelector('.js-tag-carousel') ||
  document.querySelector('.js-case-study-list') ||
  document.querySelector('.js-dynamic-case-study')
) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationTwoColumnImage" */ 'js/animations/blocks/two-column-image')
}

if (document.querySelector('.js-general-content')) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationGeneralContent" */ 'js/animations/blocks/general-content')
}

if (document.querySelector('.js-content-image')) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationContentImage" */ 'js/animations/blocks/content-image')
}

if (document.querySelector('.js-accordion')) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationAccordion" */ 'js/animations/blocks/accordion')
}

if (document.querySelector('.js-image-carousel')) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationImageGallery" */ 'js/animations/blocks/image-gallery')
}

if (document.querySelector('.js-block-intro')) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationBlockIntro" */ 'js/animations/blocks/block-intro')
}

if (document.querySelector('.js-block-outro')) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationBlockOutro" */ 'js/animations/blocks/block-outro')
}

if (document.querySelector('.js-image-caption-grid')) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationImageCaptionGrid" */ 'js/animations/blocks/image-caption-grid')
}

if (document.querySelector('.js-testimonials')) {
  import(/* webpackPrefetch: true, webpackChunkName: "animationTestimonials" */ 'js/animations/blocks/testimonials')
}
